
import React, { useCallback, useEffect, useState } from 'react';
import Header from './Header';
import axios from 'axios';
import { FaMinus, FaPlus, FaWhatsapp } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { useCart } from './CartContext';
import { RiDeleteBin6Line } from 'react-icons/ri';
import Footer2 from './Footer2';

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [openSection, setOpenSection] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [customizeData2, setCustomizeData2] = useState([]);
  const [cartData2, setCartData2] = useState([]);


  // ✅ Use global cart context
  const { cartData, fetchCartData, openCart } = useCart();

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  // ✅ Fetch customization data
  useEffect(() => {
    fetchCartData();
    axios
      .post(`${process.env.REACT_APP_SECRET_KEY}/api/viewcustomize`)
      .then((res) => {
        const data = res.data?.View_Customize?.[0] || [];
        setCustomizeData2(data);
      })
      .catch((err) => console.error('Error fetching customize data:', err));
  }, [fetchCartData]);

  // ✅ Fetch all products
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SECRET_KEY}/api/productview`)
      .then((res) => {
        if (res.data?.ProductView) setProducts(res.data.ProductView);
      })
      .catch((err) => console.error('Error fetching products:', err));

    fetchCartData();
  }, [fetchCartData]);

  // ✅ Manage quantity for modal
  // useEffect(() => {

  //   if (selectedProduct && cartData.length > 0) {
  //     const cartItem = cartData.find(
  //       (item) => item.Product_Id === selectedProduct.Product_Id
  //     );
  //     setQuantity(cartItem ? Number(cartItem.Quantity) : 1);
  //   }
  // }, [cartData, selectedProduct]);
  //add
  useEffect(() => {
    const cartItems = cartData?.AddToCartDetails?.[0] || [];

    if (selectedProduct && cartItems.length > 0) { 
      const cartItem = cartItems.find( 
        (item) => item.Product_Id === selectedProduct.Product_Id
      );
      setQuantity(cartItem ? Number(cartItem.Quantity) : 1);
    }
  }, [cartData, selectedProduct]);

  // const getProductQuantity = useCallback(
  //   (productId) => {
  //     const item = cartData.find((i) => i.Product_Id === productId);
  //     return item ? Number(item.Quantity) : 0;
  //   },
  //   [cartData]
  // );
  //add
  const getProductQuantity = useCallback(
    (productId) => {
      //add
      const cartItems = cartData?.AddToCartDetails?.[0] || [];
      const item = cartItems.find((i) => i.Product_Id === productId);
      return item ? Number(item.Quantity) : 0;
    },
    [cartData]
  );
  const fetchCartData2 = async () => {
    if (!user?.UserID) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SECRET_KEY}/api/getcartdetails`,
        { Customer_ID: user.UserID }
      );
      setCartData2(res.data);
    } catch (err) {
      // console.error("Error fetching cart data:", err);
    }
  };
  useEffect(() => {
    fetchCartData2();
  }, []);
  const handleCartWhatsAppMessage = () => {
    if (!cartData2?.AddToCartDetails?.[0]?.length) {
      toast.warn("Cart is empty!");
      return;
    }

    const message = cartData2.AddToCartDetails[0].map(item =>
      `🛍 *${item.Product_Name}*` +
      `\n📏 Quantity: ${item.Quantity}*`
      // `\n💸 Price: ₹${item.Rate}` +   
      //  // `\n💰 Total: ₹${item.TotalAmount}`
    ).join('\n\n');

    const finalAmt = cartData2?.AddToCartDetails?.[1]?.[0]?.FinalAmount || 0;
    // const encodedMessage = encodeURIComponent(`${message}\n\n🔖 Final Amount: ₹${finalAmt}`);
    const encodedMessage = encodeURIComponent(`${message}`);
    const whatsappUrl = `https://wa.me/917984785574?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  // shop.jsx - Single Product WhatsApp
  const handleProductWhatsApp = (product) => {
    const categoryName = categories.find(
      cat => cat.Miscellaneous_ID === product.Category_Id
    )?.Name || 'N/A';

    const subcategoryName = subcategories.find(
      sub => sub.Miscellaneous_ID === product.SubCategory_Id
    )?.Name || 'N/A';

    const message =
      `Hello, I would like to order this product.

Product Inquiry

────────────────────
Product: ${product.Product_Name}
Category: ${categoryName}
Subcategory: ${subcategoryName}
Size: ${product.Size || 'Standard'}
Quantity: 1
────────────────────

Thank you!`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/917984785574?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };
  // ✅ Quick View Modal
  const handleQuickView = (id) => {
    axios
      .post(`${process.env.REACT_APP_SECRET_KEY}/api/viewsinglepage`, {
        Product_Id: id,
      })
      .then((res) => {
        const product = res.data?.ProductDetails?.[0]?.[0];
        if (product) {
          setSelectedProduct(product);
          setIsModalOpen(true);
        }
      })
      .catch((err) => console.error('Error fetching product:', err));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  // ✅ Add / Update Cart
  const handleAddToCart = async () => {
    if (!selectedProduct) return;

    // if (!user?.UserID) {
    //   toast.error('Please log in first');
    //   setTimeout(() => navigate('/login'), 1500);
    //   return;
    // }
if (!user?.UserID) {
    const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
    const idx = guestCart.findIndex(i => i.Product_Id === selectedProduct.Product_Id);
    if (idx >= 0) {
        guestCart[idx].Quantity = quantity;
    } else {
        guestCart.push({
            Product_Id: selectedProduct.Product_Id,
            Product_Name: selectedProduct.Product_Name,
            Product_Img: selectedProduct.Product_Img,
            Category_Id: selectedProduct.Category_Id,
            SubCategory_Id: selectedProduct.SubCategory_Id,
            Quantity: quantity,
        });
    }
    localStorage.setItem('guestCart', JSON.stringify(guestCart));
    toast.success('Added to cart!');
    setIsModalOpen(false);
    fetchCartData();
    openCart();
    return;
}
    // const isInCart = cartData.some(
    //   (item) => item.Product_Id === selectedProduct.Product_Id
    // );
    //add
    const cartItems = cartData?.AddToCartDetails?.[0] || [];

    const isInCart = cartItems.some(
      (item) => item.Product_Id === selectedProduct.Product_Id
    );


    const endpoint = isInCart ? 'updatecartdetails' : 'addtocart';

    const data = {
      Product_ID: selectedProduct.Product_Id || null,
      Category_ID: selectedProduct.Category_Id || null,
      SubCategory_ID: selectedProduct.SubCategory_Id || null,
      Quantity: quantity || 1,
      Customer_ID: user?.UserID || null,
    };

    try {
      await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/${endpoint}`, data);
      toast.success(`Cart ${isInCart ? 'updated' : 'added'} successfully`);
      setIsModalOpen(false);
      fetchCartData();
      openCart(); // ✅ Open global drawer
    } catch (err) {
      // console.error('Error updating/adding cart:', err);
      toast.error('Cart operation failed');
    }
  };

  // ✅ Delete cart item (from global context)
  const deleteCartItem = async (item) => {
    try {
      await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/deletecartitem`, {
        Product_ID: item.Product_Id,
        Customer_ID: user.UserID,
      });

      toast.success('Item removed from cart');
      fetchCartData();

      // Smooth reload (optional)
      setTimeout(() => {
        window.location.reload();
      }, 700);
    } catch (err) {
      // console.error('Failed to delete item:', err);
      toast.error('Delete failed');
    }
  };

  // ✅ Fetch Categories
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SECRET_KEY}/api/getcategory`)
      .then((res) => setCategories(res.data?.category || []))
      .catch((err) => console.error('Error fetching categories:', err));
  }, []);

  // ✅ Fetch Subcategories
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SECRET_KEY}/api/getsubcategory`)
      .then((res) => setSubCategories(res.data?.subCategory || []))
      .catch((err) => console.error('Error fetching subcategories:', err));
  }, []);

  const toggleSection = (section) =>
    setOpenSection((prev) => (prev === section ? null : section));

  const handleCategoryFilter = (id) => {
    setSelectedCategory(id);
    setSelectedSubcategory(null);
  };

  const handleSubCategoryFilter = (id) => setSelectedSubcategory(id);

  // const filteredProducts = products.filter((p) => {
  //   const matchCat = selectedCategory ? p.Category_Id === selectedCategory : true;
  //   const matchSub = selectedSubcategory ? p.SubCategory_Id === selectedSubcategory : true;
  //   return matchCat && matchSub;
  // });
  // ... (Previous code) ...

  const filteredProducts = products.filter((p) => {

    const statusValue = String(p.Status).toLowerCase();
    const isActive = statusValue === 'true' || statusValue === '1' || statusValue === 'active';

    if (!isActive) return false;

    const matchCat = selectedCategory ? p.Category_Id === selectedCategory : true;

    const matchSub = selectedSubcategory ? p.SubCategory_Id === selectedSubcategory : true;

    return matchCat && matchSub;
  });

  return (
    <>
      <Header />
      <div className="shop-main">
        <div className="container">
          <div className="shop-inner-main">
            {/* ✅ Filters */}
            <div className="shop-child">
              <div className="shop-inner-child">
                <div className="filter-box">
                  {['category', 'subcategory'].map((type) => (
                    <div key={type} className="filter-item">
                      <div className="filter-header" onClick={() => toggleSection(type)}>
                        <span className="filter-label">
                          {type === 'category' ? 'Category' : 'Sub-Category'}
                        </span>
                        <span className="filter-icon">
                          {openSection === type ? <FaMinus /> : <FaPlus />}
                        </span>
                      </div>
                      {openSection === type && (
                        <div className="dropdown-box">
                          {(type === 'category' ? categories : subcategories).map((item) => (
                            <div className='dropdown-boxname'
                              key={item.Miscellaneous_ID}
                              onClick={() =>
                                type === 'category'
                                  ? handleCategoryFilter(item.Miscellaneous_ID)
                                  : handleSubCategoryFilter(item.Miscellaneous_ID)
                              }
                            >
                              {item.Name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ✅ Product Grid */}
            <div className="shop-child">
              <div className="myfilter-category">
                <div className="myfilter-box">
                  {['category', 'subcategory'].map((type) => (
                    <div key={type} className="myfilter-item-inline">
                      <div className="myfilter-header" onClick={() => toggleSection(type)}>
                        <span className="myfilter-label">
                          {type === 'category' ? 'Category' : 'Sub-Category'}
                        </span>
                        <span className="myfilter-icon">
                          {openSection === type ? <FaMinus /> : <FaPlus />}
                        </span>
                      </div>
                      {openSection === type && (
                        <div className="myfilter-dropdown-box">
                          {(type === 'category' ? categories : subcategories).map((item) => (
                            <div
                              key={item.Miscellaneous_ID}
                              onClick={() =>
                                type === 'category'
                                  ? handleCategoryFilter(item.Miscellaneous_ID)
                                  : handleSubCategoryFilter(item.Miscellaneous_ID)
                              }
                            >
                              {item.Name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="shop-inner-child">


                {/* static products end here */}


                {filteredProducts.map((product) => (
                  <div key={product.Product_Id} className="item">
                    <Link to={`/productt/${product.Product_Id}`}>
                      <img
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}${product.Product_Img}`}
                        alt={product.Product_Name}
                        className="imgimgimg"
                      />
                    </Link>
                    <div className="Quiek-view" onClick={() => handleQuickView(product.Product_Id)}>
                      <span>Quick view</span>
                    </div>
                    <div className="size">{product.Size}</div>
                    <div className="shop-box">
                      <span className="s1">{product.Product_Name}</span>
                      {/* <button
                        onClick={handleCartWhatsAppMessage} // <-- Use this handler
                        className="icon-li-wp"
                      > */}
                      <button
                        onClick={() => handleProductWhatsApp(product)} // <-- Use for home item 
                        className="icon-li-wp"
                      >
                        <FaWhatsapp className="top-icon-wp" />
                      </button>
                    </div>
                  </div>
                ))}

                {/* ✅ Modal */}
                <Modal
                  title={null}
                  open={isModalOpen}
                  onCancel={handleCancel}
                  footer={null}
                  centered
                  width={800}
                  zIndex={2000}
                >
                  {selectedProduct ? (
                    <div className="modal-layout">
                      <div className="modal-left">
                        <div className="modal-image-box">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${selectedProduct.Product_Img}`}
                            alt={selectedProduct.Product_Name}
                          />
                        </div>
                      </div>
                      <div className="modal-right">
                        <h2>{selectedProduct.Product_Name}</h2>
                        <p>Category: {selectedProduct.category}</p>
                        <p>Subcategory: {selectedProduct.SubCategory}</p>

                        <div className="cart-qty">
                          <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>-</button>
                          <span>{quantity}</span>
                          <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                        </div>

                        <button className="add-to-cart" onClick={handleAddToCart}>
                          {getProductQuantity(selectedProduct.Product_Id) > 0
                            ? 'Update Cart'
                            : 'Add to Cart'}
                        </button>
                        <button
                          className="add-to-cart"
                          onClick={() => {
                            handleCancel();
                            navigate(`/productt/${selectedProduct.Product_Id}`);
                          }}
                        >
                          Customize
                        </button>
                      </div>
                    </div>
                  ) : (
                    <p>Loading...</p>
                  )}
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
    </>
  );
};

export default Shop;
